module.exports = __webpack_public_path__ + "img/mask.71f97d2e.png";